import styled from '@emotion/styled';
import { Label } from '@naf/input';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { spacing } from '@naf/theme';

export const Wrapper = styled.div`
  margin-top: ${spacing.space8};
  margin-bottom: ${spacing.space56};
`;

export const StyledLabel = styled(Label)`
  font-weight: 400;
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const StyledButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    marginTop: theme.spacing(6),
  },
}));
